/* eslint-disable react/jsx-no-undef */
import React from "react";
import "./App.scss";
import {
  Route,
  Routes,
  BrowserRouter,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { Login } from "./Login/Login";
import { FamilyRegistration } from "./RegistrationForms/FamilyRegistration";
import { MemberRegistration } from "./RegistrationForms/MemberRegistration";
import { PropertyRegistration } from "./RegistrationForms/PropertyRegistration";
import { FamilyListingpage } from "./ListingPage/FamilyListingpage";
import { MemberListingpage } from "./ListingPage/MemberListingpage";
import { FamilyListingdetail } from "./ListingPage/FamilyListingdetail";
import { MemberListingdetail } from "./ListingPage/MemberListingdetail";
import { ViewFamilyMember } from "./ListingPage/ViewFamilyMember";
import { useSelector } from "react-redux";
import { HomePage } from "./HomePage";
import About from "./About_us/About";
import { DonationPage } from "./Donation/DonationPage";
import Dashboard from "./dashboard/Dashboard";
import AdminShell from "./dashboard/AdminShell";
import AppriciationModel from "./Stripe/AppriciationModel";
import { DetailPage } from "./dashboard/Family/DetailPage";
import { MemberDetailPage } from "./dashboard/Member/DetailPage";
import { DonationFilters } from "./dashboard/Donation/DonationFilters";
import { ApplicationDetail } from "./dashboard/Applicaton/ApplicationDetail";
import { ViewApplicationMember } from "./dashboard/Applicaton/ViewApplicationMember";
import { PropertyListing } from "./ListingPage/PropertyListing";
import { Propertylistingdetail } from "./ListingPage/Propertylistingdetail";
import { ProgramDetail } from "./dashboard/Programs/ProgramDetail";
import MedicalStoredetail from "./dashboard/Medicalstaff/MedicalStoredetail";
import RegisterMedicalStore from "./RegistrationForms/RegisterMedicalStore";
import CasesFeeds from "./Cases_feeds/CasesFeeds";
import PostCase from "./Cases_feeds/PostCase";
import {Programs} from "./Programs/Programs";
import { ProgramDetails } from "./Programs/ProgramDetails";
import SpecificCase from "./Cases_feeds/SpecificCase";
import CaseDonationStats from "./Cases_feeds/CaseDonationStats";
import Blogs from './blogs/Blogs'
import BlogDetails from "./blogs/components/BlogDetails";
import ImsDetails from "./dashboard/ims/ImsDetails";
import "./css/site-ui.css";


// These forms are built as pop-ups that a parent page closes. Opened from their
// own URL there is no parent, so closing goes back to the previous page.
const RoutedForm = ({ form: Form }) => {
  const navigate = useNavigate();
  return <Form setShowModal={() => navigate(-1)} />;
};

function App() {
  const { isLogin } = useSelector((state) => state.authSlice);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} exact />
        <Route path="/login" element={<Login />} />
        <Route path="/aboutus" element={<About />} />
        <Route path="/casesfeeds" element={<CasesFeeds/>} />
        <Route path="/casesfeeds/:id" element={<SpecificCase/>} />
        <Route path="/caseDonationStats/:id" element={<CaseDonationStats/>} />
        <Route path="/postcase" element={<PostCase/>} />
        <Route path="/programs" element={<Programs/>} />
        <Route path="/programDetail/:id" element={<ProgramDetails/>} />
        <Route path="/donation" element={<DonationPage />} />
        <Route path="/donation/:id" element={<DonationPage />} />
        <Route path="/appericiation" element={<AppriciationModel />} />
        <Route path='/blogs' element={<Blogs/>}/> 
        <Route path="/blog-details/:id" element={<BlogDetails/>}/>
        {/* Signed-in pages share the admin shell. URLs stay as they were. */}
        <Route element={isLogin ? <AdminShell /> : <Navigate to="/login" />}>
          <Route path="/familyRegistration" element={<RoutedForm form={FamilyRegistration} />} />
          <Route path="/memberRegistration" element={<RoutedForm form={MemberRegistration} />} />
          <Route path="/medicalstoreRegistration" element={<RoutedForm form={RegisterMedicalStore} />} />
          <Route path="/propertyRegistration" element={<RoutedForm form={PropertyRegistration} />} />
          <Route
            path="/familylisting"
            element={<FamilyListingpage />}
          />
          <Route
            path="/memberlisting"
            element={<MemberListingpage />}
          />
          <Route
            path="/familydetailpage"
            element={<DetailPage />}
          />
          <Route
            path="/donationdetailpage"
            element={<DonationFilters />}
          />
          <Route
            path="/memberdetailpage"
            element={<MemberDetailPage />}
          />
          <Route
            path="/propertydetailpage"
            element={<PropertyListing />}
          />
          <Route
            path="/familylistingdetail/:id"
            element={<FamilyListingdetail />}
          />
          <Route
            path="/applicationdetail/:id"
            element={<ApplicationDetail />}
          />
          <Route
            path="/applicationMember/:id"
            element={<ViewApplicationMember />}
          />
          <Route
            path="/memberlistingdetail/:id"
            element={<MemberListingdetail />}
          />
          <Route
            path="/medicalstoredetail/:id"
            element={<MedicalStoredetail />}
          />
          <Route
            path="/imsdetail/:id"
            element={<ImsDetails />}
          />
          <Route
            path="/propertylistingdetail/:id"
            element={<Propertylistingdetail />}
          />
          <Route
            path="/viewmember/:id"
            element={<ViewFamilyMember />}
          />
          <Route
            path="/dashboard/programDetail/:id"
            element={<ProgramDetail />}
          />
          <Route
            path="/dashboard/*"
            element={<Dashboard />}
          />
        </Route>

        {/* If none of the above routes match, redirect to the home page */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
